import {ReachSegment} from "../../apis/requests/templates/types";

export type SegmentTagGroups = {
  exclusive: ReachSegment[];
  general: ReachSegment[];
  validation: ReachSegment[];
};

const isValidationSegment = (segment: ReachSegment) => segment.type === "VALIDATION";

export const groupSegmentTags = (segments: ReachSegment[], validationOnly: boolean): SegmentTagGroups => {
  const byPriority = [...segments].sort((a, b) => a.priority - b.priority);
  if (validationOnly) return {exclusive: [], general: [], validation: byPriority.filter(isValidationSegment)};
  return {
    exclusive: byPriority.filter((segment) => segment.type === "EXCLUSIVE"),
    general: byPriority.filter((segment) => segment.type === "GENERAL"),
    validation: [],
  };
};

export const selectableSegments = (groups: SegmentTagGroups): ReachSegment[] => [
  ...groups.exclusive,
  ...groups.general,
  ...groups.validation,
];

export const segmentIdsMatchingTemplateType = (
  segmentIds: number[],
  segments: ReachSegment[],
  isValidationTemplate: boolean
): number[] => {
  const segmentById = new Map(segments.map((segment) => [segment.id, segment]));
  return segmentIds.filter((id) => {
    const segment = segmentById.get(id);
    return !segment || isValidationSegment(segment) === isValidationTemplate;
  });
};

export const findSelectedExclusiveId = (selectedIds: number[], groups: SegmentTagGroups): number | undefined =>
  groups.exclusive.find((segment) => selectedIds.includes(segment.id))?.id;

export const nextSegmentSelection = (
  previousIds: number[],
  requestedIds: number[],
  groups: SegmentTagGroups
): number[] => {
  const addedExclusiveId = groups.exclusive.find(
    (segment) => requestedIds.includes(segment.id) && !previousIds.includes(segment.id)
  )?.id;
  if (addedExclusiveId !== undefined) return [addedExclusiveId];
  return requestedIds;
};
